import React, {useEffect, useState} from 'react';
import Moment from 'react-moment';
// import ICONS from "assets/images/index.js";
// import vegaEmbed from 'vega-embed';
import moment from 'moment';
// import { Icon } from 'helpers/icons';
// import { FaPrint } from 'react-icons/fa';
import { usePrintTrendsMutation } from '../../../services/labService';
import { shallowEqual, useSelector } from 'react-redux';
// import { dataURItoFile } from 'helpers/common.lib';
import { useGetPatientQuery } from '../../../services/patientService';
import { Icon } from '../../../helpers/icons';
import { dataURItoFile } from '../../../helper';
// import { useGetPatientQuery } from 'app/redux/patientService';

const ResultTrends = ({test}) => {
    const [historicTrendCollapse, setHistoricTrendCollapse] = useState({});
    const [printInProgressId, setPrintInProgressId] = useState(null);


    const { auth, selectedNote } = useSelector(
        ({ auth, providerNote }) => ({
          auth,
          selectedNote: providerNote.selectedNote,
        }),
        shallowEqual
    );

    const { data: selectedPatient } = useGetPatientQuery(selectedNote?.pid);

    const toggleHistoricTrends = (trend_dom_id) => {
        const val = historicTrendCollapse[trend_dom_id] ? false : true;
        setHistoricTrendCollapse({...historicTrendCollapse, [trend_dom_id]: val })
    }

    const initTrendingChart = (chartID, chartData) =>{
        
        const graphData = chartData.map((data)=>{
            let date = moment(data.date).format('MM/DD/YYYY');
            return {...data, date, result_date: date }
        })

        const yourVlSpec = {
            $schema: 'https://vega.github.io/schema/vega-lite/v5.json',
            // name: 'result_chart',
            description: 'A simple line chart with embedded data.',
            // title: 'Line chart',
            data: {
                values: graphData
            },
            width:800,
            height: 200,
            // background: 'red',
            // padding: '15',
            // color: '#fff',
            transform: [
                {filter: "datum.value !='-'"}
            ],
            mark: { type: 'line', point: true, tooltip: {content: "encoding"}},
            config: {
                view:{ 
                    cursor: 'pointer',
                    // fill: 'yellow'
                }
            },
            encoding: {
                x: {field: 'result_date', type: 'ordinal', title: 'Result Date', scale: {zero: false}, axis: {labelAngle: 0}},
                // y: {field: 'value', type: 'quantitative', title: 'Value', scale: {zero: false}},
                y: {field: 'value', type: 'nominal', title: 'Value', scale: {zero: false}},

            }
            
            // resolve: {scale: {color: '#000'}}
        };
        
        if(!historicTrendCollapse[chartID]){
            // vegaEmbed('#vis_'+chartID, yourVlSpec);
        }
    }

    useEffect(()=>{
        if(test?.observations?.length){
            test.observations?.map((result, index)=>{
                initTrendingChart(`${test.id}_${result.ltscode}_${index}`, result.date_range)
            })
        }
    }, [test.observations])

    const [printTrends] = usePrintTrendsMutation();
    const printLabTestObservationTrends = async(result, index) =>{
        
        let formData = new FormData();
        let tempPostData = []

        var graphDiv = document.getElementById(`vis_${test.id}_${result.ltscode}_${index}`);
        var wrapperDiv = graphDiv.getElementsByTagName('div')[0];
        var canvas = wrapperDiv.getElementsByTagName('canvas')[0];

        // Create in meomery canvas with different size
        var smallCanvas = document.createElement("canvas");
        var smallContext = smallCanvas.getContext("2d")
        smallCanvas.width = 650;
        smallCanvas.height = 450;
        smallContext.clearRect(0, 0, smallCanvas.width, smallCanvas.height);
        smallContext.drawImage(canvas, 0, 0, smallCanvas.width, smallCanvas.height);

        var file = dataURItoFile(smallCanvas.toDataURL(), test.id+' '+result.short_desc);

        
        formData.append(`file[${result.id}]`, file);

        tempPostData.push([{...result}]);

        formData.append('patient', JSON.stringify({dos: selectedNote.encounter_data.date, name: selectedPatient.Patient?.full_name, age: selectedPatient.Patient?.age, dob: selectedPatient.Patient?.DOB, mrn: selectedPatient?.Patient?.mrn}));
        formData.append("file_data", JSON.stringify(tempPostData));

        setPrintInProgressId(result.id)
        const res = await printTrends(formData);
        setPrintInProgressId(null)

        if(res?.data?.code == 0){
            window.open( process.env.REACT_APP_API_URL_V1 + '/utilities/get_attachment.json?attachment='+ res.data?.data?.uuid +'&token=' + auth.authToken +"&tz="+ new Date().getTimezoneOffset() + '&practice_id=' + auth.practice_id, "_blank");
        }
    }

    return(
        <>
            <div className='border-l-steal-c-100 border-l-4'>
                {test?.observations?.length ? 
                    <div className="flex items-center bg-slate-100 px-2 h-[40px] gap-x-8 justify-between">
                        <p className="font-normal text-base w-40">
                            Observations  
                        </p>
                        <p className="font-normal text-base w-32">
                            Range   
                        </p>
                        {test?.result_dates?.map((date, index)=>{
                            return index < 4 ? (
                                <p key={index} className="font-normal text-base w-32">
                                    <Moment format="MM/DD/YYYY">
                                        {date ? date : '-'}
                                    </Moment> 
                                </p>
                            ) : null
                        })}
                        <p className="font-normal text-base w-32">
                            Historic Trend   
                        </p>
                    </div>
                    :
                    <div className="flex flex-row items-center bg-slate-100 px-2 py-2 gap-x-8">
                        <p className="font-normal text-base w-full text-center">
                            No Results found.
                        </p>
                    </div>
                }
            </div>

            <div className='divide-y divide-gray-200 bg-white alternative-color border-l-4'>
                {test.observations?.map((result, index)=>{
                    return(
                        <div key={index}>
                            <div className={`border-b-2 flex font-light items-center px-2 py-2 gap-x-4 justify-between ${result.abnormal_result && 'bg-red-200'}`}>
                                <div className="flex items-center gap-x-3 w-40">
                                    {/* <img src={ICONS.icObservation} className="icon-w-14 icon-h-14" alt="" /> */}
                                    <p className="font-normal">
                                        {result.short_desc}
                                    </p>
                                </div>
                                <div className="font-light w-32">
                                    { result.range_min ? `${result.range_min} - ${result.range_max} ${result.unit}`: '-'}
                                </div>
                                {result.date_range?.map((obj, indx)=>{
                                    return indx < 4 ? 
                                        <div key={indx} className="w-32 flex gap-1 items-center align-middle" style={{color: `${obj.color_code}`}}>
                                            {obj.arrow ? <Icon type={obj.arrow == 'up' ? 'up_arrow_red' : 'down_arrow_red'}/> : null}
                                            {obj.value}
                                        </div>
                                    : null
                                })}
                                <div className='flex gap-2 w-32'>
                                    <button onClick={() => {toggleHistoricTrends(`${test.id}_${result.ltscode}_${index}`);}} title="Trends">
                                        {/* <img src={ICONS.ictrend} className="icon-w-14 icon-h-14" alt="" /> */}
                                    </button>
                                    {printInProgressId == result.id ?
                                        <Icon type="inline-loader" />
                                        :
                                        <FaPrint className='cursor-pointer' title="Print" onClick={()=>printLabTestObservationTrends(result, index)} />
                                    }
                                </div>
                            </div>
                            <div className={`flex flex-row w-full p-3 justify-between ${historicTrendCollapse[`${test.id}_${result.ltscode}_${index}`] ? '' : 'hidden'}`}>
                                <div id={`vis_${test.id}_${result.ltscode}_${index}`}></div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}

export default ResultTrends;